"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _themeGet = _interopRequireDefault(require("@styled-system/theme-get"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _styledSystem = require("styled-system");

var _theme = _interopRequireDefault(require("../../theme"));

var _Box = _interopRequireDefault(require("../Box"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var inputs = (0, _styledSystem.variant)({
  key: 'inputs'
});
var Input = (0, _styledComponents["default"])(_Box["default"]).withConfig({
  displayName: "Input",
  componentId: "sc-1hgprp0-0"
})({
  borderWidth: '1px',
  borderStyle: 'solid',
  lineHeight: '1.25'
}, _styledSystem.fontFamily, _styledSystem.fontWeight, _styledSystem.lineHeight, _styledSystem.borders, _styledSystem.borderColor, _styledSystem.borderRadius, _styledSystem.textAlign, inputs, function (props) {
  var px = (0, _themeGet["default"])('space.2')(props);
  var py = px - 1; // to account for borders

  return "padding: ".concat(py, "px ").concat(px, "px;");
});
Input.propTypes = _objectSpread({}, _styledSystem.borders.propTypes);
Input.defaultProps = {
  as: 'input',
  border: 'medium',
  bg: 'white',
  borderRadius: 3,
  fontSize: 1,
  theme: _theme["default"],
  textAlign: 'left'
};
var _default = Input;
exports["default"] = _default;